import PropTypes from "prop-types";
import shape from "./types/shape";

const message = (propType, message) => {
    return function () {
        const args = Array.prototype.slice.call(arguments);
        const error = propType.apply(null, args);
        if (error) {
            return new Error(message);
        }
    }
}

export default {
    Sales: {
        pos: message(shape({
            id: PropTypes.number.isRequired
        }), "Kérlek válassz eladási helyet!")
    }
}